import { render } from "./EditMenu.vue?vue&type=template&id=3c3dd354&ts=true"
import script from "./EditMenu.vue?vue&type=script&lang=ts"
export * from "./EditMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__